<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">
      <div class="row m-3">

        <div class="col-lg-3 mb-4 order-2 order-sm-1 order-md-1">
          <MenuAction/>
        </div>

        <div class="col-lg-9 order-1 order-sm-2 order-md-2">
            <p class="h4">
                <b>Escolha o convênio</b>
            </p>

          <div class="mb-4">
            <div class="form-icon position-relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-search fea icon-sm icons">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input name="insurance" id="insurance" class="form-control ps-5" placeholder="Pesquisar convênio" v-model="search">
            </div>
          </div>

          <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate" @click="selectInsurance(insurance)"
               style="cursor: pointer;" v-for="insurance in insurances">
            <div class="m-3">
              <p class="h6 text-primary">{{insurance.insurance_name}}</p>
              <b class="text-muted mb-0">{{insurance.nick_name ?? insurance.trading_name}}</b>
            </div>
          </div>

          <div class="card shadow text-center rounded border-0 mb-3 p-4" v-if="insurances.length <= 0">
            <img :src="require('@/assets/images/no_datal.svg')"
                 alt="Foto" class="w-25 align-self-center"/>

            <p class="h4 mt-3">Opss... Nenhum convênio encontrado.</p>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MenuAction from './MenuAction.vue'
import Alert from "../../helpers/alert";
import Str from "../../helpers/str";
import {mask} from "vue-the-mask";
import http from "../../helpers/http";

export default {
  directives: {
    mask,
  },
  name: 'Insurance',
  components: {
    MenuAction
  },
  data() {
    return {
      search: '',
      selectedIsurance: '',
    }
  },
  computed: {
    insurances() {
      let insurances = this.$store.state.toSchedule.insurances;
      if (this.search === '')
        return insurances;

      return insurances.filter(insurance => {
        let strFilter = JSON.stringify(insurance);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  mounted() {
    this.$store.dispatch('toSchedule/getInsurances');
    this.$store.dispatch('toSchedule/getPaymentMethods');
  },
  methods: {
    selectInsurance(insurance) {
      this.selectedIsurance = insurance;

      if (insurance.is_insurance) {
        let paymentMethods = this.$store.state.toSchedule.paymentMethods;
        let paymentMethod = paymentMethods.find(pm => pm.paymeth_type === 'CO');

        if (!paymentMethod) {
          Alert.error("Nenhum método de pagamento compatível foi encontrado para este convênio.");
          return;
        }

        this.$store.commit('toSchedule/selectPaymentMethod', paymentMethod);
        this.$store.commit('toSchedule/selectInsurance', insurance);
        this.$router.push('/professionals');
      } else {
        this.$store.commit('toSchedule/selectPlan', insurance.plan);
        this.$store.commit('toSchedule/selectInsurance', insurance);
        this.$router.push('/payment-methods?except=CO');
      }
    },
  }
}
</script>

<style scoped>

</style>
